import React from "react";
import styles from "./Contact.css";
import { Panel, Button, Row, Col } from "react-bootstrap";
import { isA, isReporter, getStrValue } from "../../store/utility";
import * as UIConstants from "../../components/UI/UIConstants";
//import Switch from "rc-switch";

class Contact extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: this.props.data,
      originalData: this.props.data,
      editing: false,
      forname: {
        value: this.getPropValue("data", "forname"),
        defaultValue: "Prénom",
        displayDefault: this.getPropValue("data", "forname").length === 0,
      },
      name: {
        value: this.getPropValue("data", "name"),
        defaultValue: "Nom",
        displayDefault: this.getPropValue("data", "name").length === 0,
      },
      email: {
        value: this.getPropValue("data", "email"),
        defaultValue: "Adresse électronique",
        displayDefault: this.getPropValue("data", "email").length === 0,
      },
      phone: {
        value: this.getPropValue("data", "phone"),
        defaultValue: "Téléphone fixe",
        displayDefault: this.getPropValue("data", "phone").length === 0,
      },
      cellular: {
        value: this.getPropValue("data", "cellular"),
        defaultValue: "Téléphone portable",
        displayDefault: this.getPropValue("data", "cellular").length === 0,
      },
      byDefault: {
        value:
          this.getPropValue("data", "byDefault").length === 0
            ? false
            : this.getPropValue("data", "byDefault"),
        defaultValue: "",
        displayDefault: this.getPropValue("data", "byDefault").length === 0,
      },
    };
  }
  getPropValue = (obj, property) => {
    if (this.props[obj] === null || this.props[obj][property] === null) {
      return "";
    }

    return this.props[obj][property];
  };
  //LifeCycle
  componentWillReceiveProps(nextProps) {
    if (
      this.props.data !== nextProps.data ||
      this.props.editing !== nextProps.editing
    ) {
      var _state = this.state;
      _state["data"] = nextProps.data;
      _state["originalData"] = nextProps.data;
      _state["editing"] = nextProps.editing;
      _state["forname"].value = getStrValue(nextProps.data.forname);
      _state["forname"].displayDefault =
        getStrValue(nextProps.data.forname).length === 0;
      _state["name"].value = getStrValue(nextProps.data.name);
      _state["name"].displayDefault =
        getStrValue(nextProps.data.name).length === 0;
      _state["email"].value = getStrValue(nextProps.data.email);
      _state["email"].displayDefault =
        getStrValue(nextProps.data.email).length === 0;
      _state["phone"].value = getStrValue(nextProps.data.phone);
      _state["phone"].displayDefault =
        getStrValue(nextProps.data.phone).length === 0;
      _state["cellular"].value = getStrValue(nextProps.data.cellular);
      _state["cellular"].displayDefault =
        getStrValue(nextProps.data.cellular).length === 0;
      _state["byDefault"].value = nextProps.data.byDefault;

      this.setState(_state);
    }
  }

  //Handler
  resetHandler = (event) => {
    event.preventDefault();
    var _originalData = this.state.originalData;
    this.setState({ data: _originalData });
    this.props.disableOthersEditing(null);
  };

  enabledHandler = (event) => {
    event.preventDefault();
    var _data = this.state.data;
    _data.enabled = !_data.enabled;
    this.props.saveOrUpdate(_data);
  };

  saveHandler = (event) => {
    event.preventDefault();
    
    let { data } = this.state;
    data.name = this.state.name.value;
    data.forname = this.state.forname.value;
    data.email = this.state.email.value;
    data.phone = this.state.phone.value;
    data.cellular = this.state.cellular.value;
    data.byDefault = this.state.byDefault.value;
    const company = this.state.data.company;
    if (company.id) {
      data.company = {
        "id": company.id,
        "name": company.name,
      }
    }

    this.props.saveOrUpdate(data);
  };

  editHandler = (event) => {
    event.preventDefault();
    this.props.disableOthersEditing(this.props.data.id);
  };

  validChangeHandler = () => {
    return (
      this.validateEmail(this.state.email.value) &&
      (this.state.forname.value !== this.state.data.forname ||
        this.state.name.value !== this.state.data.name ||
        this.state.byDefault.value !== this.state.data.byDefault ||
        this.state.email.value !== this.state.data.email ||
        this.state.phone.value !== this.state.data.phone ||
        this.state.cellular.value !== this.state.data.cellular) &&
      this.state.data.company &&
      null != this.state.data.company
    );
  };

  changeInputHandler = (event, obj) => {
    var _state = this.state;
    const eventTragetId = event.target.id.substr(0, event.target.id.indexOf("_"));
    _state[eventTragetId].value = event.target.value;
    _state[eventTragetId].displayDefault =
      event.target.value.trim().length === 0;
    this.setState(_state);
  };

  changeSwitchHandler = (id, value) => {
    var _state = this.state;
    _state[id].value = value;
    this.setState(_state);
  };

  changeCompanyHandler = (event) => {
    var _state = this.state;
    var _company = null;
    for (var i = 0; i < this.props.companies.length; i++) {
      if (
        parseInt(this.props.companies[i].id, 10) ===
        parseInt(event.target.value, 10)
      ) {
        _company = this.props.companies[i];
        break;
      }
    }

    _state.data.company = _company;
    this.setState(_state);
  };

  displayDefault = (val) => {
    if (val.displayDefault) {
      return val.defaultValue;
    }
    return val.value;
  };

  validateEmail = (email) => {
    var matches = UIConstants.EMAIL_VALIDATION_REGEX.exec(email);
    return matches && matches.length > 0;
  };

  render() {
    if (this.state.data === null || !this.state.data) {
      return null;
    }
    //const data = this.state.data;
    const { data } = this.state;
    const editing = this.props.editing;
    return (
      <Panel bsStyle={this.state.data.enabled ? "primary" : "danger"}>
        <Panel.Heading
          className="clearfix"
          style={{ padding: "5px", paddingLeft: "10px" }}
        >
          <div className="pull-left">
            {this.state.data.id === null ? (
              isA() || isReporter() ? (
                <select
                  style={{ color: "#000" }}
                  onChange={(event) => this.changeCompanyHandler(event)}
                >
                  <option value="0">--- Choisir ---</option>
                  {this.props.companies.filter((c) => c.activated !== false).map((company, index) => {
                    return (
                      <option key={index} value={company.id}>
                        {company.name.trim()}
                      </option>
                    );
                  })}
                  ;
                </select>
              ) : (
                this.props.company.name.trim()
              )
            ) : (
              this.state.data.company.name.trim()
            )}
          </div>
          {this.props.editing ? null : (
            <div className="pull-right">
              <i
                className={
                  this.state.data.enabled ? "fa fa-trash-o" : "fa fa-undo"
                }
                style={{ cursor: "pointer" }}
                onClick={(event) => this.enabledHandler(event)}
              />
            </div>
          )}
        </Panel.Heading>
        <Panel.Body style={{ paddingTop: "5px" }}>
          <Row>
            <Col sm={1} />
            <Col sm={5}>
              <input
                type="text"
                id={`forname_${data.id}`}
                style={{ textAlign: "right" }}
                placeholder={editing ? this.state.forname.defaultValue : ""}
                className={
                  editing
                    ? this.state.forname.displayDefault
                      ? styles.editableField
                      : styles.editableExistField
                    : styles.normalField
                }
                disabled={!editing}
                onChange={(event) => this.changeInputHandler(event)}
                value={this.state.forname.value}
              />
            </Col>
            <Col sm={5}>
              <input
                type="text"
                id={`name_${data.id}`}
                placeholder={editing ? this.state.name.defaultValue : ""}
                className={
                  editing
                    ? this.state.name.displayDefault
                      ? styles.editableField
                      : styles.editableExistField
                    : styles.normalField
                }
                disabled={!editing}
                onChange={(event) => this.changeInputHandler(event)}
                value={this.state.name.value}
              />
            </Col>
            <Col sm={1} />
          </Row>
          <Row>
            <Col sm={1}>
              <i className="fa fa-envelope" />
            </Col>
            <Col sm={10}>
              <input
                type="email"
                id={`email_${data.id}`}
                placeholder={editing ? this.state.email.defaultValue : ""}
                className={
                  editing
                    ? this.state.email.displayDefault
                      ? styles.editableField
                      : styles.editableExistField
                    : styles.normalField
                }
                disabled={!editing}
                onChange={(event) => this.changeInputHandler(event)}
                onBlur={(event) => this.validateEmail(event)}
                value={this.state.email.value}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={1}>
              <i className="fa fa-phone" />
            </Col>
            <Col sm={10}>
              <input
                type="text"
                id={`phone_${data.id}`}
                placeholder={editing ? this.state.phone.defaultValue : ""}
                className={
                  editing
                    ? this.state.phone.displayDefault
                      ? styles.editableField
                      : styles.editableExistField
                    : styles.normalField
                }
                disabled={!editing}
                onChange={(event) => this.changeInputHandler(event)}
                value={this.state.phone.value}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={1}>
              <i className="fa fa-mobile-phone" />
            </Col>
            <Col sm={10}>
              <input
                type="text"
                id={`cellular_${data.id}`}
                placeholder={editing ? this.state.cellular.defaultValue : ""}
                default={this.state.cellular.defaultValue}
                className={
                  editing
                    ? this.state.cellular.displayDefault
                      ? styles.editableField
                      : styles.editableExistField
                    : styles.normalField
                }
                disabled={!editing}
                onChange={(event) => this.changeInputHandler(event)}
                value={this.state.cellular.value}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={1}>
              <input
                type="checkbox"
                id={`byDefault_${data.id}`}
                /*className={editing ? this.state.cellular.displayDefault ? styles.editableField : styles.editableExistField : styles.normalField}*/
                disabled={!editing}
                onChange={(event) => this.changeInputHandler(event)}
                value={this.state.byDefault.value}
              />
            </Col>
            <Col sm={10}>Présent sur toutes les demandes</Col>
          </Row>
        </Panel.Body>
        <Panel.Footer className="clearfix">
          <div className="pull-left">
            {this.props.editing ? (
              this.state.data.id === null ? (
                <Button
                  bsStyle="danger"
                  bsSize="xsmall"
                  onClick={(event) => this.props.hideContact(event)}
                >
                  <i className="fa fa-ban" />
                  &nbsp;Annuler
                </Button>
              ) : (
                <Button
                  bsStyle="danger"
                  bsSize="xsmall"
                  onClick={(event) => this.resetHandler(event)}
                >
                  <i className="fa fa-ban" />
                  &nbsp;Annuler
                </Button>
              )
            ) : null}
          </div>
          <div className="pull-right">
            {this.props.editing ? (
              <Button
                bsStyle="success"
                bsSize="xsmall"
                disabled={!this.validChangeHandler()}
                onClick={(event) => this.saveHandler(event)}
              >
                <i className="fa fa-check" />
                &nbsp;Valider
              </Button>
            ) : (
              <Button
                bsStyle="info"
                bsSize="xsmall"
                onClick={(event) => this.editHandler(event)}
              >
                <i className="fa fa-edit" />
                &nbsp;&Eacute;diter
              </Button>
            )}
          </div>
        </Panel.Footer>
      </Panel>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/containers/Contact/Contact.js